import { AxiosError } from 'axios';
import { UserGroupApproverRequest } from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import { POST_CREATE_DATA_ARCHIVAL_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { CompleteDataArchivalContent } from './useGetDataArchivalDetail';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request / Response
// =============================================================================

interface CreateDataArchivalRequest {
  dataArchival: {
    examYear: string;
    content: CompleteDataArchivalContent[];
  };
  requestCreationModel: UserGroupApproverRequest;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: any) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateDataArchival = ({ onSuccess, onError }: Input) => {
  const postCreateDataArchival = async (payload: CreateDataArchivalRequest) => {
    const res = await axiosClient.post<undefined>(POST_CREATE_DATA_ARCHIVAL_URL, payload);
    return res.data;
  };

  return useCustomMutation(postCreateDataArchival, {
    onSuccess,
    onError,
  });
};
